import type { ApiError } from '@/shared/api';

const FALLBACK = 'Die Änderung wurde nicht gespeichert. Bitte versuchen Sie es erneut.';

// Diese Ablehnungen kommen beim Speichern eines Objekts vor; ihr Servertext ist teils Englisch
// und spricht von Topologie statt von dem, was der Nutzer gerade getan hat.
const KNOWN: Record<string, string> = {
  object_distribution_binding_blocks_relocation:
    'Unter dieser Adresse gibt es schon ein Objekt. Zusammenführen ist gesperrt, solange eines der beiden beim Kanalmanager veröffentlicht ist.',
  object_distribution_values_mismatch:
    'Unter dieser Adresse gibt es schon ein Objekt mit anderer Währung oder Zeitzone. Zusammenführen geht nur bei gleichen Werten.',
  object_distribution_topology_changed:
    'Die Objekte wurden gerade an anderer Stelle geändert. Bitte versuchen Sie es erneut.',
};

// Diese Codes tragen einen deutschen Satz, der für sich steht.
const OWN_WORDS = new Set(['object_access_denied', 'object_not_found']);

/**
 * Der Satz, der im Sheet stehen bleibt. Ein Serverfehler oder ein Netzproblem nennt nie den
 * internen Text („See server logs…"), eine Feldablehnung nicht die englischen Validator-Meldungen —
 * die Felder prüft das Formular mit denselben Grenzen ohnehin selbst.
 */
export function saveFailureMessage(problem: ApiError): string {
  // Ohne Antwort ist offen, ob der Server gespeichert hat — der Satz darf nicht „nein“ sagen.
  if (problem.status === 0) {
    return 'Keine Antwort vom Server – ob gespeichert wurde, ist offen. Bitte prüfen Sie die Verbindung.';
  }
  if (problem.status >= 500) return FALLBACK;
  const known = KNOWN[problem.title];
  if (known) return known;
  if (problem.fieldErrors) {
    return 'Die Angaben wurden nicht angenommen. Bitte prüfen Sie die Eingaben.';
  }
  if (OWN_WORDS.has(problem.title) && problem.detail) return problem.detail;
  if (problem.status === 403) return 'Dafür fehlt Ihnen die Berechtigung.';
  return FALLBACK;
}
